import HNavbar from "../../components/Base/HNavbar";

const Davivienda = ({ subRoutes }) => {
  return <HNavbar links={subRoutes} isIcon />;
};

export default Davivienda;

